import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-blog-two-column',
  templateUrl: './breadcrumb-blog-two-column.component.html',
  styleUrls: ['./breadcrumb-blog-two-column.component.css']
})
export class BreadcrumbBlogTwoColumnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
